import {ssrLazy} from 'ssr/lazy';

export const PlaceDetailsLazy = ssrLazy(() => import(/* webpackChunkName: "placeDetails" */ '.'));
